/**
 * Lazy loader for the Firebase Cloud Functions handler.
 *
 * The handler pulls in large Firebase SDK chunks, so we only want to
 * import it when a feature explicitly needs to talk to Cloud Functions.
 */

type CloudFunctionsModule = typeof import('./cloudFunctionsHandler')

let cloudFunctionsModulePromise: Promise<CloudFunctionsModule> | null = null

export const loadCloudFunctionsHandler = (): Promise<CloudFunctionsModule> => {
  if (!cloudFunctionsModulePromise) {
    cloudFunctionsModulePromise = import('./cloudFunctionsHandler')
  }

  return cloudFunctionsModulePromise
}
